import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { HighlightPipe } from '../../pipes/highlight.pipe';
import { AccountSearchComponent } from './account-search.component';
import { SearchResultRowDirective } from '../../directives/search-result-row.directive';
import { AccountSearchService } from './account-search.service';
import { SpinnerModule } from '@charlesschwab/as-ui-core';
import { AccountNumberPipe } from '../../pipes/account-number.pipe';



@NgModule({
    imports: [CommonModule, FormsModule, OverlayModule, SpinnerModule, AccountSearchComponent],
    exports: [AccountSearchComponent],
    providers: [AccountSearchService]
})
export class AccountSearchModule {}
